import React, { useState, useEffect } from "react";
import { Button, Col, Flex } from "antd";
import {
  Typography,
  Grid,
  Stack,
  Chip,
  Box,
  IconButton,
  Tooltip,
  TextField,
  Autocomplete,
  colors,
} from "@mui/material";
import { useParams } from "react-router";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ReceiptIcon from "@mui/icons-material/Receipt";
import ReContract from "assets/images/recontract.svg";
import { useAuth } from "../../../../hooks/useAuth";
import dayjs from "dayjs";

import api from "_api";

import {
  GradientButton,
  GradientButtonOutline,
} from "components/GradientButton";
import CustomTable from "components/TableExplanded/Table";
import TableData from "../columns";
import useColumns from "../columns/detail/userColumns";

//ASSET
import Approved_icon from "assets/images/Approved.svg";
import waitting_icon from "assets/images/waitting.svg";
import notApproved_icon from "assets/images/noteApprove.svg";
import canceled_icon from "assets/images/canceled.svg";

import Modal from "components/Modal/SuperAdmin/create/createUser";
import ModalAddDate from "components/Modal/SuperAdmin/create/addDateCompanyPackage";
import { Link } from "react-router-dom";
import ModalViewPackageMarketPlace from "components/Modal/SuperAdmin/view/viewPackageMarketplace";
import {
  Add,
  Cancel,
  Check,
  CheckCircle,
  CheckOutlined,
  Close,
  CloseOutlined,
  Delete,
  ManageSearch,
  Remove,
  Timelapse,
  UploadFile,
  UploadFileOutlined,
} from "@mui/icons-material";
import {
  formatCurrency2Digit,
  formatDateMonthYear,
} from "utils/helpers/format";
import { getStatusColor } from "utils/helpers/statusColors";
import ModalSendSlipInvoice from "components/Modal/SuperAdmin/create/sendSlipInvoice";
import ModalConfirm from "components/Modal/ModalConfirm";

const Detail = () => {
  const [approvedActive, setApprovedActive] = useState(false);
  const [isApproved, setIsApproved] = useState(0);
  const [companyData, setCompanyData] = useState([]);
  const [addressData, setAddressData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [marketplace, setMarketplace] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedProduct, setProduct] = useState(null);
  const [companyUsePackage, setCompanyUsePackage] = useState([]);
  const [isAddDateOpen, setIsAddDateOpen] = useState(false);
  const [packageTypeActive, setPackageTypeActive] = useState(null);
  const [companyPackageActive, setCompanyPackageActive] = useState(null);
  const [isPackageMarketPlaceActive, setIsPackageMarketPlaceActive] =
    useState(false);
  const [packageMarketplaceData, setPackageMarketplaceData] = useState(null);
  const [billDebtData, setBillDebtData] = useState([]);

  const [isModalSendSlip, setIsModalSendSlip] = useState(false);
  const [isModalConfirmCancel, setIsModalConfirmCancel] = useState(false);

  const { role } = useAuth();

  let params = useParams();
  const [marketplaceHeader] = useState([
    { label: "ชื่อแพ็คเกจ" },
    { label: "เครดิตทั้งหมด" },
    { label: "ยอดคงเหลือ" },
    { label: "วันที่เริ่มต้น" },
    { label: "สถานะ" },
    { label: "" },
  ]);

  const [companyUsePackageHeader] = useState([
    { label: "ประเภท" },
    { label: "การใช้งาน" },
    { label: "วันหมดอายุ" },
    { label: "อนุมัติ" },
    { label: "" },
  ]);

  const BillDebt = [
    {
      label: "เลขที่ใบแจ้งหนี้",
    },
    { label: "เลขที่ใบเสร็จรับเงิน" },
    { label: "ประเภท" },
    { label: "ยอดเงิน" },
    { label: "พิมพ์ใบแจ้งหนี้" },
    { label: "สถานะใบแจ้งหนี้" },
    { label: "พิมพ์ใบเสร็จรับเงิน" },
    { label: "สถานะ" },
    { label: "" },
  ];

  const fetchCompanyData = async (id) => {
    const result = await api.super_admin.getCompanyData(id);
    const companyPackageData = await result?.data?.CompanyPackages?.filter(
      (item) => item.company_package_id == params.package_id
    );

    if (result.isStatus) {
      setIsApproved(companyPackageData ? companyPackageData[0]?.approved : 0);

      setCompanyData([
        { label: "รหัส MID", data: result?.data?.mid },
        { label: "ชื่อร้าน", data: result?.data?.company_name },
        { label: "เลขประจำตัวผู้เสียอากร", data: result?.data?.tax_id_number },
        {
          label: "ชื่อเจ้าของร้าน/ผู้ทำธุรกรรม",
          data: result?.data?.owner_name,
        },
        { label: "ชื่อผู้ติดต่อ", data: result?.data?.contact },
        { label: "เบอร์โทรศัพท์", data: result?.data?.phone },
        { label: "อีเมล", data: result?.data?.email },
        { label: "สถานะ", data: result?.data?.company_status },
        {
          label: "โลโก้",
          data: (
            <img
              src={`${result?.data?.company_logo ?? null}`}
              alt="logo"
              style={{
                aspectRatio: "1/1",
                objectFit: "cover",
                width: "75px",
                height: "75px",
              }}
            />
          ),
        },
      ]);

      setAddressData([
        { label: "อาคาร", data: result?.data?.building ?? "-" },
        { label: "ที่อยู่", data: result?.data?.alley ?? "-" },
        { label: "ถนน", data: result?.data?.road ?? "-" },
        { label: "ตำบล/แขวง", data: result?.data?.amphure ?? "-" },
        { label: "อำเภอ/เขต", data: result?.data?.district ?? "-" },
        { label: "จังหวัด", data: result?.data?.province ?? "-" },
        { label: "รหัสไปรษณีย์", data: result?.data?.zipcode ?? "-" },
      ]);

      const updatedUserData =
        result?.data?.Users.map((item) => ({
          id: item.user_id,
          username: item.username,
          name: item.name,
          role: item.Role.name,
          status: item.status,
          user_approved: item.approved,
        })) ?? [];

      setUserData(updatedUserData);
    }
  };

  const getApprovedOption = (value) => {
    if (value === 0) return { label: "ไม่อนุมัติ", value: 0 };
    if (value === 1) return { label: "อนุมัติ", value: 1 };
    return null;
  };

  const fetchUsePackage = async () => {
    const response = await api.super_admin.getCompanyUsePackage(
      params.company_id
    );

    const rankedFilter = response?.data.filter((item) => item.ranks == null);

    const sortData = rankedFilter.map((item) => ({
      package_name: item.package_name,
      is_used: (
        <Chip
          label={item.is_used}
          style={{
            width: "100px",
            background: `${
              item.is_used === "ใช้งานอยู่"
                ? "#2E7D32"
                : item.is_used === "หมดอายุ" || item.is_used === "ไม่อนุมัติ"
                ? "#D32F2F"
                : item.is_used === "ไม่ใช้งาน"
                ? "#2E2E2E"
                : item.is_used === "ใกล้หมดอายุ"
                ? "#F3B600"
                : "#F18807"
            }`,
            color: "white",
            textTransform: "capitalize",
          }}
        />
      ),
      date_expire: item.date_expire
        ? dayjs(item.date_expire).format("DD/MM/YYYY")
        : "-",
      approved:
        item.is_used !== "ไม่ใช้งาน" ? (
          role === "SuperAdminA" || role === "admin" ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "150px",
              }}
            >
              <Autocomplete
                options={[
                  { label: "ไม่อนุมัติ", value: 0 },
                  { label: "อนุมัติ", value: 1 },
                ]}
                getOptionLabel={(option) => option.label}
                getOptionSelected={(option, value) =>
                  option.value === value.value
                }
                disableClearable
                value={
                  item.is_used !== "ตรวจสอบ"
                    ? getApprovedOption(item.approved)
                    : null
                }
                onChange={(event, newValue) => {
                  api.super_admin
                    .approvedCompanyPackage(item.company_package_id, {
                      status: newValue.value,
                    })
                    .then(() => {
                      fetchUsePackage();
                    });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="ตรวจสอบ"
                  />
                )}
                sx={{
                  width: "150px",
                  "& .MuiOutlinedInput-root": {
                    bgcolor: "white",
                    height: "40px",
                    color:
                      item.is_used === "ตรวจสอบ"
                        ? "black"
                        : item.approved === 0
                        ? "red"
                        : item.approved === 1
                        ? "green"
                        : "black",
                  },
                }}
                error={false}
                helperText=""
              />
            </Box>
          ) : (
            <Stack direction="row" spacing={1}>
              <img
                src={
                  item.is_used === "ตรวจสอบ"
                    ? waitting_icon
                    : item.approved === 1
                    ? Approved_icon
                    : item.approved === 0
                    ? notApproved_icon
                    : null
                }
                alt="status icon"
              />
            </Stack>
          )
        ) : (
          "-"
        ),
      action:
        role !== "SuperAdminA" ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "row",
              gap: 1,
            }}
          >
            <Tooltip title="ต่ออายุแพ็คเกจ" placement="top">
              <IconButton
                onClick={() => {
                  setIsAddDateOpen(true);
                  setPackageTypeActive(item.package_type_id);
                  setCompanyPackageActive(item.company_package_id);
                }}
                sx={{
                  backgroundColor: "primary.main",
                  color: "white",
                  width: "25px",
                  height: "25px",
                  "&:hover": {
                    backgroundColor: "primary.main",
                  },
                  borderRadius: "50%",
                }}
              >
                <Add
                  sx={{
                    width: "20px",
                    height: "20px",
                    color: "white",
                  }}
                />
              </IconButton>
            </Tooltip>
          </Box>
        ) : null,
    }));
    setCompanyUsePackage(sortData);
  };

  const fetchMarketPlaceCompany = async (id) => {
    const result = await api.super_admin.getCompanyMarketPlace(id);
    console.log("result", result);

    const updatedMarketplace =
      result?.data?.map((item) => ({
        package_name: item.name_package,
        total_credit: item.total_credit,
        total_credit_remain: item.total_credit_remain,
        start_date: formatDateMonthYear(item.start_date),
        status: (
          <Stack direction="row" spacing={1}>
            <img
              src={getMarketplacePackage(item.status).icon}
              alt="status icon"
            />
          </Stack>
        ),
        action: (
          <Flex gap={5}>
            <div
              style={{ cursor: "pointer" }}
              onClick={() => {
                setIsPackageMarketPlaceActive(true);
                setPackageMarketplaceData(item);
              }}
            >
              <VisibilityIcon color="primary" />
            </div>
            {role !== "SuperAdminA" && (
              <div>
                <DeleteIcon color="error" />
              </div>
            )}
          </Flex>
        ),
      })) ?? [];
    setMarketplace(updatedMarketplace);
  };

  const handleApprovedStatusInvoice = async (status, id) => {
    await api.super_admin
      .updateInvoiceStatus(id, status, params.company_id)
      .then((res) => {
        if (res.isStatus) {
          fetchBillDebt(params.company_id);
        }
      })
      .catch((err) => {
        console.error("Error updating invoice status:", err);
      });
  };

  const handleCancelInvoice = async (id) => {
    await api.super_admin
      .cancelBillInvoice(id)
      .then((res) => {
        if (res.isStatus) {
          fetchBillDebt(params.company_id);
          setIsModalConfirmCancel(false);
        }
      })
      .catch((err) => {
        console.error("Error canceling invoice:", err);
      })
      .finally(() => {
        setIsModalConfirmCancel(false);
      });
  };

  const fetchBillDebt = async (company) => {
    const result = await api.super_admin.getBillDebt(company);
    console.log("billdebt", result);

    const newData = result?.data.map((data, key) => {
      const { package_types } = data;
      return {
        invoice: data.invoice,
        receipt: data.receipt ?? "-",
        package_types:
          package_types && package_types.length > 0
            ? package_types
                .map((pkg) =>
                  pkg == 1
                    ? "ระบบโรงรับจำนำ หรือร้านค้าทั่วไป"
                    : pkg == 2
                    ? "ระบบรถมือสอง"
                    : "ระบบที่ดิน"
                )
                .join(", ")
            : "-",
        balance: data.net_amount,
        printinvoice: (
          <Flex
            align="center"
            gap={5}
            onClick={() => {
              window.open(
                `${process.env.REACT_APP_BASE_URL}/manage/pdf-bill/${data.id}`
              );
            }}
            style={{ cursor: "pointer" }}
          >
            <ReceiptIcon /> ใบแจ้งหนี้
          </Flex>
        ),
        status_invoice:
          role !== "SuperAdminM" && data.status_inv == "ตรวจสอบ" ? (
            <Box
              sx={{
                display: "flex",
                // justifyContent: "center",
                alignItems: "center",
                flexDirection: "row",
                gap: 2,
              }}
            >
              <IconButton
                onClick={() => {
                  // setIsPackageMarketPlaceActive(true);
                  // setPackageMarketplaceData(data);
                  handleApprovedStatusInvoice("อนุมัติ", data.id);
                }}
                sx={{
                  color: "#2E7D32",
                  width: "30px",
                  height: "30px",
                  border: "1px solid #949494",
                  borderRadius: "50%",
                  fontSize: "15px",
                  "&:hover": {
                    backgroundColor: "#2E7D32",
                    color: "white",
                    border: "1px solid #2E7D32",
                  },
                }}
              >
                <CheckOutlined />
              </IconButton>

              <Box
                sx={{
                  width: "1px",
                  height: "25px",
                  backgroundColor: "#949494",
                  display: "inline-block",
                }}
              />

              <IconButton
                onClick={() => {
                  // setIsPackageMarketPlaceActive(true);
                  // setPackageMarketplaceData(data);
                  handleApprovedStatusInvoice("ยกเลิก", data.id);
                }}
                sx={{
                  color: "#D32F2F",
                  width: "30px",
                  height: "30px",
                  border: "1px solid #949494",
                  borderRadius: "50%",
                  fontSize: "15px",
                  "&:hover": {
                    backgroundColor: "#D32F2F",
                    color: "white",
                    border: "1px solid #D32F2F",
                  },
                }}
              >
                <CloseOutlined />
              </IconButton>
            </Box>
          ) : (
            <Stack direction="row" spacing={1}>
              <img
                src={getAprrovedBillStatus(data.status_inv).icon}
                alt="status icon"
              />
            </Stack>
          ),
        printreceipt: data.receipt ? (
          <Flex
            align="center"
            gap={5}
            style={{ cursor: "pointer" }}
            onClick={() => {
              window.open(
                `${process.env.REACT_APP_BASE_URL}/manage/getPdfReceiptInv/${data.id}`
              );
            }}
          >
            <ReceiptIcon /> ใบเสร็จรับเงิน
          </Flex>
        ) : (
          ""
        ),
        status: (
          <Chip
            label={data.status_slip}
            style={{
              width: "100px",
              backgroundColor: getStatusColor(data.status_slip).color,
              color: "white",
              textTransform: "capitalize",
            }}
          />
        ),
        action: data.status_inv !== "ยกเลิก" && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "row",
              gap: 1,
            }}
          >
            {role !== "SuperAdminA" && (
              <>
                {data.status_inv != "ตรวจสอบ" &&
                  data.status_slip !== "ชำระแล้ว" && (
                    <IconButton
                      sx={{
                        width: "30px",
                        height: "30px",
                        borderRadius: "50%",
                        // backgroundColor: "warning.main",
                        fontSize: "20px",
                        "&:hover": {
                          color: "white",
                          backgroundColor: "primary.main",
                        },
                        color: colors.grey,
                      }}
                      onClick={() => {
                        setIsModalSendSlip(true);
                        setProduct(data);
                      }}
                    >
                      <UploadFile />
                    </IconButton>
                  )}
                {/* <Box
                  sx={{
                    width: "1px",
                    height: "25px",
                    backgroundColor: "#949494",
                    display: "inline-block",
                  }}
                /> */}
                {data.status_inv != "อนุมัติ" && (
                  <IconButton
                    sx={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "50%",
                      // backgroundColor: "warning.main",
                      fontSize: "20px",
                      "&:hover": {
                        color: "white",
                        backgroundColor: "primary.main",
                      },
                      color: colors.grey,
                    }}
                    onClick={() => {
                      setProduct(data);
                      setIsModalConfirmCancel(true);
                    }}
                  >
                    <Delete />
                  </IconButton>
                )}
              </>
            )}
            {/* {role !== "SuperAdminM" && data.status_inv == "อนุมัติ" && ( */}
            {role !== "SuperAdminM" && data.slip != null && (
              <IconButton
                sx={{
                  width: "30px",
                  height: "30px",
                  borderRadius: "50%",
                  "&:hover": {
                    color: "white",
                    backgroundColor: "primary.main",
                  },
                  fontSize: "20px",
                  color: "#949494",
                }}
                onClick={() => {
                  setIsModalSendSlip(true);
                  setProduct(data);
                }}
              >
                <ManageSearch />
              </IconButton>
            )}
          </Box>
        ),
      };
    });
    setBillDebtData(newData);
  };
  useEffect(() => {
    fetchCompanyData(params.company_id);
    fetchMarketPlaceCompany(params.company_id);
    fetchBillDebt(params.company_id);
    fetchUsePackage();
  }, []);

  const columns = useColumns();

  const getMarketplacePackage = (approved) => {
    switch (approved) {
      case "approved":
        return {
          label: "Approved",
          color: "green",
          icon: Approved_icon,
        };
      case "pending":
        return {
          label: "Waitting",
          color: "orange",
          icon: waitting_icon,
        };
      default:
        return {
          label: "Not Approved",
          color: "red",
          icon: notApproved_icon,
        };
    }
  };

  const getAprrovedBillStatus = (approved_status) => {
    console.log("billStatus", approved_status);
    switch (approved_status) {
      case "อนุมัติ":
        return {
          label: "อนุมัติ",
          color: "#2E7D32",
          // icon: <CheckCircle />,
          icon: Approved_icon,
        };
      case "ตรวจสอบ":
        return {
          label: "ตรวจสอบ",
          color: "#FD7E14",
          // icon: <Timelapse />,
          icon: waitting_icon,
        };
      default:
        return {
          label: "ยกเลิก",
          color: "#D32F2F",
          // icon: <Cancel />,
          icon: canceled_icon,
        };
    }
  };

  const handleModalOpen = () => {
    setModalOpen(!isModalOpen);
    if (selectedProduct && isModalOpen) setProduct(null);
  };

  const handleApprovedCompany = async (status) => {
    await api.super_admin.approvedCompanyPackage(params.package_id, {
      status: status,
    });
    setIsApproved(status);
    setApprovedActive(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: 0,
        gap: 1,
      }}
    >
      <Box
        sx={{
          justifyContent: "flex-start",
          p: 0,
          mb: 2,
        }}
      >
        <GradientButtonOutline onClick={() => window.history.back()}>
          กลับ
        </GradientButtonOutline>
        {/* <div>
          <Flex gap={5} align="center">
            {approvedActive && (
              <Flex justify="space-between" gap={5}>
                <Button
                  style={{ border: "none", backgroundColor: "inherit" }}
                  className="btn-approved"
                  onClick={async () => {
                    await handleApprovedCompany(1);
                  }}
                >
                  <img
                    src={Approved_icon}
                    alt="approved_icon"
                    className="w-5 h-5"
                  />
                </Button>
                <Button
                  style={{ border: "none", backgroundColor: "inherit" }}
                  className="btn-deny"
                  onClick={async () => {
                    await handleApprovedCompany(2);
                  }}
                >
                  <img
                    src={notApproved_icon}
                    alt="notapproved_icon"
                    className="w-5 h-5"
                  />
                </Button>
              </Flex>
            )}

            <GradientButtonOutline
              onClick={() => setApprovedActive(!approvedActive)}
              disabled={role == "SuperAdminM"}
            >
              {isApproved == 0
                ? "รอผลการตรวจสอบ"
                : isApproved == 1
                ? "อนุมัติแล้ว"
                : "ไม่อนุมัติ"}
            </GradientButtonOutline>
          </Flex>
        </div> */}
      </Box>

      <Box
        sx={{
          display: "flex",
          paddingRight: 3,
        }}
      >
        <Flex gap="large">
          <Col span={12}>
            <div>
              <TableData
                headers={[{ label: "รายละเอียดร้านค้า" }]}
                datas={companyData}
                isTable={false}
              />
            </div>
            <div>
              <Typography
                component="div"
                style={{ fontSize: "16px", fontWeight: "bolder", mb: 2 }}
              >
                สัญญาการใช้งาน
              </Typography>
              <TableData
                headers={companyUsePackageHeader}
                datas={companyUsePackage}
                isTable={true}
              />
            </div>
            <div>
              <Typography
                component="div"
                style={{ fontSize: "16px", fontWeight: "bolder", mb: 2 }}
              >
                แพ็คเกจ MarketPlace
              </Typography>
              <TableData
                headers={marketplaceHeader}
                datas={marketplace}
                isTable={true}
              />
            </div>
          </Col>
          <Col span={12}>
            <div>
              <TableData
                headers={[{ label: "ที่ตั้ง" }]}
                datas={addressData}
                isTable={false}
              />
            </div>
            <div>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                <Typography
                  component="div"
                  style={{ fontSize: "16px", fontWeight: "bolder" }}
                >
                  ผู้ใช้งาน
                </Typography>
                {(role === "SuperAdminM" || role === "admin") && (
                  <GradientButton onClick={handleModalOpen}>
                    สร้างผู้ใช้งาน
                  </GradientButton>
                )}
              </Box>
              <CustomTable
                columns={columns}
                data={userData}
                fetchData={() => fetchCompanyData(params.company_id)}
              />
            </div>
          </Col>
        </Flex>
      </Box>
      <Flex gap="large">
        <Col span={24}>
          {/* <div> */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "10px",
              alignItems: "center",
            }}
          >
            <Typography
              component="div"
              style={{
                fontSize: "16px",
                fontWeight: "bolder",
              }}
            >
              ใบเสร็จรับเงิน
            </Typography>
            {role !== "SuperAdminA" && (
              <Link to={`/admin/company/create-invoice/${params.company_id}`}>
                <GradientButton>สร้างใบแจ้งหนี้</GradientButton>
              </Link>
            )}
          </Box>

          <TableData headers={BillDebt} datas={billDebtData} isTable={true} />
          {/* </div> */}
        </Col>
      </Flex>

      <Modal
        open={isModalOpen}
        onClose={handleModalOpen}
        selectedProduct={selectedProduct}
        fetchProductData={() => fetchCompanyData(params.company_id)}
        companyId={params.company_id}
      />

      <ModalAddDate
        open={isAddDateOpen}
        onClose={() => setIsAddDateOpen(!isAddDateOpen)}
        companyId={params.company_id}
        package_type_id={packageTypeActive}
        company_package_id={companyPackageActive}
        fetchProductData={fetchUsePackage}
        setPackageTypeActive={setPackageTypeActive}
      />

      <ModalViewPackageMarketPlace
        open={isPackageMarketPlaceActive}
        onClose={() =>
          setIsPackageMarketPlaceActive(!isPackageMarketPlaceActive)
        }
        selectedProduct={packageMarketplaceData}
        fetchProductData={() => fetchMarketPlaceCompany(params.company_id)}
      />

      <ModalSendSlipInvoice
        companyId={params.company_id}
        open={isModalSendSlip}
        onClose={() => setIsModalSendSlip(!isModalSendSlip)}
        bill={selectedProduct}
        isEdit={false}
        fetchData={() => fetchBillDebt(params.company_id)}
      />

      <ModalConfirm
        open={isModalConfirmCancel}
        onClose={() => setIsModalConfirmCancel(!isModalConfirmCancel)}
        message={"ยืนยันยกเลิกใบแจ้งหนี้รายการนี้หรือไม่?"}
        onConfirm={() => handleCancelInvoice(selectedProduct.id)}
        type="delete"
      />
    </Box>
  );
};

export default Detail;
